import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "selectorWrapper", "playerWrapper", "muteBtn"]
  static values = {
    enabled: Boolean,
    preference: String
  }

  connect() {
    // On load: sync DOM with values from Rails
    this.updateToggleState(this.enabledValue)
    this.setDropdownSelection(this.preferenceValue)
    this.applyMuteState(this.readMutePreference(), { fromUser: false })
  }

  toggleVoiceSkins() {
    const isActive = this.toggleTarget.dataset.active === "true"
    const newState = !isActive

    this.updateToggleState(newState)

    const pref = newState ? this.getDropdownValue() : null
    this.sendVoicePreference(newState, pref)
  }

  updatePreference(event) {
    const preference = event.target.value
    const isEnabled = this.toggleTarget.dataset.active === "true"

    if (isEnabled) {
      this.sendVoicePreference(true, preference)
    }
  }

  updateToggleState(enabled) {
    this.toggleTarget.dataset.active = enabled
    this.toggleTarget.textContent = `Voice Skins: ${enabled ? "On" : "Off"}`
    this.toggleTarget.classList.toggle("bg-green-700", enabled)
    this.toggleTarget.classList.toggle("bg-gray-800", !enabled)
    localStorage.setItem("voiceSkinsEnabled", enabled ? "true" : "false")

    if (this.hasSelectorWrapperTarget) {
      this.selectorWrapperTarget.classList.toggle("hidden", !enabled)
    }
  }

  toggleMuteAll() {
    const muted = !this.readMutePreference()
    this.applyMuteState(muted, { fromUser: true })
  }

  setDropdownSelection(preference) {
    const select = this.element.querySelector("select")
    if (select && preference) {
      select.value = preference
    }
  }

  getDropdownValue() {
    const select = this.element.querySelector("select")
    return select ? select.value : null
  }

  readMutePreference() {
    try {
      return localStorage.getItem("voiceSkinsMuted") === "true"
    } catch {
      return false
    }
  }

  applyMuteState(muted, { fromUser } = { fromUser: false }) {
    if (this.hasMuteBtnTarget) {
      const btn = this.muteBtnTarget
      const icon = btn.querySelector(".icon")
      btn.classList.toggle("is-on", muted)
      btn.setAttribute("aria-pressed", muted ? "true" : "false")
      btn.setAttribute("aria-label", muted ? "Unmute voice skins" : "Mute voice skins")
      if (icon) icon.textContent = muted ? "🔇" : "🔊"
    }

    if (fromUser) {
      try {
        localStorage.setItem("voiceSkinsMuted", muted ? "true" : "false")
      } catch {}
    }

    window.dispatchEvent(new CustomEvent("voice-skins:mute-changed", {
      detail: { muted }
    }))
  }

  sendVoicePreference(enabled, preference) {
    fetch("/users/update_voice_preference", {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        voice_enabled: enabled,
        voice_preference: preference
      })
    }).then(res => {
      if (res.ok) {
        console.log(`✅ Voice preference set: ${preference} (enabled: ${enabled})`)
      } else {
        console.warn("⚠️ Failed to update voice preference")
      }
    })
  }
}
